module.exports = __webpack_public_path__ + "img/list36.f177c872.jpeg";